import * as actionTypes from './actionTypes';

export const addSingleBet=(bet)=>({
    type:actionTypes.ADD_SINGLE_BET,
    payload:bet
})